import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";
import React, { Fragment, useCallback } from "react";
import { useRouter } from "next/router";
import { SignInPage } from "../auth/pages/SignInPage";
import { PageHead } from "../helpers/PageHead";
import { AuthRoutes } from "../auth/AuthRoutes";
import { getRedirectToFromQuery } from "../auth/redirectTo";
function SignInRoute(param) {
    var serverRedirectTo = param.redirectTo;
    var router = useRouter();
    // The "join Nxmoov" invitation carries the address we already hold for the
    // candidate (NXM-747). Prefilled and locked, because the account is linked to
    // their candidate profile by email match -- signing up with a different
    // address silently produces an account with no messages in it.
    var invitedEmail = router.query.email;
    var redirectTo = getRedirectToFromQuery(router.query) || serverRedirectTo || undefined;
    /* const handleSignIn = useCallback<(afterSignInRoute?: string | null) => void>(
    async (afterSignInRoute) => {
      // user: { cityId: MayBeUserCityId } | null
       await router.prefetch(afterSignInRoute || JobsRoutes.index());
      await router.push(afterSignInRoute || JobsRoutes.index());
       // if (user?.cityId) {
      //   await router.prefetch(JobsRoutes.index());
      //   await router.push(JobsRoutes.index());
      //   return;
      // }
      //
      // await router.prefetch(AuthRoutes.createProfile());
      // await router.push(AuthRoutes.createProfile());
    },
    [router]
  ); */ var onSignInSuccessful = useCallback(function(email) {
        return router.push(AuthRoutes.confirmEmail(email));
    }, [
        router
    ]);
    /* const handleSignInWithMagicLink = useCallback<() => void>(
    () => router.push(AuthRoutes.magicLink()),
    [router]
  ); */ return /*#__PURE__*/ _jsxs(Fragment, {
        children: [
            /*#__PURE__*/ _jsx(PageHead, {
                i18nTitle: "Sign in to Nxmoov"
            }),
            /*#__PURE__*/ _jsx(SignInPage, {
                onSignInSuccessful: onSignInSuccessful,
                callbackUrl: redirectTo,
                candidateInvitedEmail: typeof invitedEmail === "string" && invitedEmail ? invitedEmail : undefined
            })
        ]
    });
}
export var __N_SSP = true;
// export async function getServerSideProps({ req }: GetServerSidePropsContext) {
//   const { user } = await supabaseClient.auth.api.getUserByCookie(req);
//
//   if (user) {
//     return {
//       props: {},
//       redirect: { destination: JobsRoutes.post(), permanent: false }
//     };
//   }
//
//   return { props: {} };
// }
export default _withSuperJSONPage(SignInRoute);
